module.exports = __webpack_public_path__ + "img/Inflammation-CECA_10X_CC.c249e165.png";